import { render, staticRenderFns } from "./Preview.vue?vue&type=template&id=bcc271ce&scoped=true&"
import script from "./Preview.vue?vue&type=script&lang=js&"
export * from "./Preview.vue?vue&type=script&lang=js&"
import style0 from "./Preview.vue?vue&type=style&index=0&id=bcc271ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc271ce",
  null
  
)

export default component.exports